var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-popup"},[_c('div',{staticClass:"base-popup__content"},[_c('div',{staticClass:"base-popup__actions"},[_vm._t("actions"),_c('button',{staticClass:"base-popup__close-button",on:{"click":function($event){return _vm.$emit('close')}}},[_c('close-icon')],1)],2),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }